import { useContext } from 'react';
import { AuthContext } from "../AuthContext";
export var useMe = function useMe() {
  var context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useMe must be used within an AuthProvider');
  }
  return context.data;
};
export default useMe;